module.exports = __webpack_public_path__ + "static/media/logo.98d72e5b.png";